import React from 'react';
import { Button, Empty } from '@chatui/core';
import './style.css';
import { DotLoader } from '../../Loader';
const logo = require('../../../assets/logo_gray.png');

export const InitialErrorMessage = () => {
  return (
    <div className="initial-message">
      <Empty type="error" tip="Could not load the Virtual Assistant">
        <Button
          color="primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          Reload
        </Button>
      </Empty>
    </div>
  );
};

export const InitialLoadingMessage = () => {
  return (
    <div className="initial-message">
      <Empty tip="Preparing your Virtual Assistant..." image={logo} />
      <DotLoader />
    </div>
  );
};
